// Liens de marque JoSmartTech (fixes). Réseaux + contact direct.
export const SOCIALS = {
  youtube: 'https://www.youtube.com/@JoSmartTech',
  facebook: 'https://www.facebook.com/share/19wH9YmBwP/',
  tiktok: 'https://www.tiktok.com/@josmarttech',
};

export const CONTACT = {
  whatsapp: '14313345083', // +1 431 334 5083
  email: 'support.josmarttech@gmail.com',
};
